import { createEvent } from "effector";

import { DateRangeFilterState } from "./DateRangeFilterState";

export const updateDateRangeFilter = createEvent<DateRangeFilterState>("updateDateRangeFilter");
export const resetDateRangeFilter = createEvent("resetDateRangeFilter");
